import React from 'react';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { practiceAreas } from '../data/expertise';
export function Expertise() {
  return <>
      <PageHero breadcrumb="Our Expertise" title="Practice areas built around the roles that matter most." lead="From the boardroom to critical functional leadership, each practice combines specialist knowledge with a single, rigorous search methodology." data-id="element-271" data-mp="24d5gcut4lmd6" />
      <section className="bg-ivory" data-id="element-272" data-mp="1glzxs7vswfz6">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-273" data-mp="1lkktbu03ybha">
          <ul className="border-b border-midnight-900/15" data-id="element-274" data-mp="1lmnrx2fbtcxm">
            {practiceAreas.map(area => <li key={area.id} id={area.id} className="scroll-mt-36 border-t border-midnight-900/15" data-id="element-275" data-mp="1qhb5454vqkww">
                <Reveal className="grid gap-6 py-12 lg:grid-cols-12 lg:gap-10 lg:py-16" data-id="element-276" data-mp="2x22k7swlbgme">
                  <h2 className="font-serif text-3xl text-midnight-900 md:text-4xl lg:col-span-4" data-id="element-277" data-mp="320xebr00crlt">{area.title}</h2>
                  <p className="text-[17px] leading-relaxed text-midnight-900/75 lg:col-span-4" data-id="element-278" data-mp="1s75ymsuk6kdg">{area.summary}</p>
                  <ul className="space-y-2.5 lg:col-span-3 lg:col-start-10" data-id="element-279" data-mp="1o5c28wrec2j3">
                    {area.focus.map(item => <li key={item} className="flex gap-3 text-[15px] text-midnight-900/80" data-id="element-280" data-mp="1j5fymymm2d42">
                        <span className="mt-2.5 h-px w-4 shrink-0 bg-champagne-500" aria-hidden="true" data-id="element-281" data-mp="1e8g1jd7qokp3" />
                        {item}
                      </li>)}
                  </ul>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>
      <CtaBand data-id="element-282" data-mp="10h1626wnar15" />
    </>;
}